import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=698e0fd8&scoped=true&"
import script from "./Tutorials.vue?vue&type=script&lang=ts&"
export * from "./Tutorials.vue?vue&type=script&lang=ts&"
import style0 from "./Tutorials.vue?vue&type=style&index=0&id=698e0fd8&scoped=true&lang=css&"
import style1 from "./Tutorials.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698e0fd8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSkeletonLoader,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('698e0fd8')) {
      api.createRecord('698e0fd8', component.options)
    } else {
      api.reload('698e0fd8', component.options)
    }
    module.hot.accept("./Tutorials.vue?vue&type=template&id=698e0fd8&scoped=true&", function () {
      api.rerender('698e0fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/infodayco/tutorials/views/Tutorials.vue"
export default component.exports